import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import StatItem from './StatItem';

const OfferStats = ({
  className,
  offerClicks = null,
  offerComments = null,
  offerLikes,
  selectedOfferStats,
}) => (
  <div
    className={twMerge(
      'flex items-center text-neutral-low-500 dark:text-neutral-high-100',
      className
    )}
  >
    {selectedOfferStats.offerComments && (
      <StatItem count={offerComments} iconName="chat-filled" size="size3" />
    )}
    {selectedOfferStats.offerLikes && (
      <StatItem count={offerLikes} iconName="like-filled" size="size2" />
    )}
    {selectedOfferStats.offerClicks && (
      <StatItem count={offerClicks} iconName="visibility" size="size3" />
    )}
  </div>
);

OfferStats.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offerClicks: PropTypes.number,
  offerComments: PropTypes.number,
  offerLikes: PropTypes.number,
  selectedOfferStats: PropTypes.shape().isRequired,
};

export default OfferStats;
